<template>
  <div class="harvesting h-100 d-flex flex-column flex-1">
    <template v-if="!!rosMap && rosMap.scene.scaleX === 1">
      <div
        style="z-index: 99; left: 0"
        class="loader position-fixed top-0 start-0 bg-white h-100 w-100 opacity-90 d-flex justify-content-center align-items-center"
      >
        <div class="d-flex align-items-center">
          <i class="material-icons">hourglass_empty</i>
          <strong>{{$t('global.loading')}}</strong>
        </div>
      </div>
    </template>
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
      <div class="btn-group mr-2" role="group" aria-label="First group">
        <button type="button" class="btn btn-primary" @click="sendCommand('Start')">
          <i class="material-icons">play_arrow</i>
        </button>
        <button type="button" class="btn btn-primary" @click="sendCommand('Kill')">
          <i class="material-icons">stop</i>
        </button>
      </div>
      <div class="btn-group mr-2" role="group" aria-label="Second group">
        <button type="button" class="btn btn-primary" @click="gotoHome()">
          <i class="material-icons">home</i>
        </button>
        <button type="button" class="btn btn-primary" @click="gotoLocation()">
          <i class="material-icons">flare</i>
        </button>
        <button type="button" class="btn btn-primary" @click="gotoUnload()">
          <i class="material-icons">input</i>
        </button>
      </div>

      <div class="btn-group ml-auto" role="group" aria-label="Third group">
        <router-link class="nav-link btn btn-secondary" to="/settings">
          <i class="material-icons">settings</i>
        </router-link>
      </div>
    </div>
    <div class="statistics">
      <div
        v-if="harvestingState != 'idle'"
      >{{ $t('global.state') }}: {{harvestingState}}, {{ $t('global.eta') }}: {{harvestingEta}} {{ $t('global.min') }}, {{ $t('global.progress') }}: {{harvestingProgress}}%, {{ $t('global.boxes') }}: {{harvestingBoxes}}</div>
      <div v-else>{{ $t('global.state') }}: {{harvestingState}}</div>
    </div>

    <div class="map">
      <i
        v-if="!!rosMap && !!farm.home"
        class="material-icons flare"
        :style="{ left: rosToGlobal(rosMap, {x: farm.home[0], y: farm.home[1]}).x - 12 + 'px', top: rosToGlobal(rosMap, {x: farm.home[0], y: farm.home[1]}).y - 10 + 'px' }"
      >home</i>
      <i
        v-show="showFlare"
        class="material-icons flare"
        v-bind:style="{ left: gotoX - 12 + 'px', top: gotoY - 10 +'px' }"
      >flare</i>
      <Map v-on:coordinates="sendXY" name="harvest" :farmId="farm.id" @initMap="initMap" />
    </div>
    <v-dialog />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";
import Map from "@/components/Map.vue";
import RosService from "@/services/RosService.js";

export default {
  name: "Harvest",
  props: ["id"],
  data() {
    return {
      farm: {},
      rosMap: null
    };
  },
  components: {
    Map
  },
  beforeMount() {
    this.farm = this.$store.state.farms.all.find(
      farm => farm.id == parseInt(this.id)
    );
    RosService.sendMappingCommand("Enter", this.farm.id);
  },
  computed: {
    ...mapState({
      harvestingState: state => state.chat.diagnostics.harvestingState,
      harvestingEta: state => state.chat.diagnostics.harvestingEta,
      harvestingProgress: state => state.chat.diagnostics.harvestingProgress,
      harvestingBoxes: state => state.chat.diagnostics.harvestingBoxes,
      gotoX: state => state.chat.diagnostics.gotoX,
      gotoY: state => state.chat.diagnostics.gotoY,
      gotoCommand: state => state.chat.diagnostics.gotoCommand,
      confirmationRequired: state => state.confirmationRequired
    }),
    showHome() {
      return this.farm.homeX != null && this.farm.homeY != null;
    },
    showFlare() {
      return this.gotoX != null && this.gotoX != null;
    }
  },
  methods: {
    initMap(viewer) {
      this.rosMap = viewer;
    },
    sendXY(values) {
      if (this.gotoCommand == "Goto") {
        const convertedCoordinates = this.globalToRos(
          this.rosMap,
          values.x,
          values.y
        );
        console.log(convertedCoordinates);
        console.log(
          "Sending goto location command " +
            convertedCoordinates.x +
            "," +
            convertedCoordinates.y
        );
        RosService.sendHarvestCommand(
          "Goto",
          convertedCoordinates.x,
          convertedCoordinates.y
        );

        this.$store.dispatch("chat/setAttribute", { gotoCommand: null });
        this.$store.dispatch("chat/setAttribute", {
          gotoX: convertedCoordinates.x
        });
        this.$store.dispatch("chat/setAttribute", {
          gotoY: convertedCoordinates.y
        });
      }
    },
    sendCommand(command) {
      if (
        !this.confirmationRequired ||
        confirm(this.$t("global.confirmation_question"))
      ) {
        RosService.sendHarvestCommand(command);
        this.clearFlare();
      }
    },
    gotoLocation() {
      if (
        !this.confirmationRequired ||
        confirm(this.$t("global.go_to_location"))
      ) {
        this.$store.dispatch("chat/setAttribute", { gotoCommand: "Goto" });
      }
    },
    toPercentX(x) {
      return Math.floor((x / 350) * 100);
    },
    toPercentY(y) {
      return Math.floor((y / 500) * 100);
    },
    toPixelsX(x) {
      return Math.floor((x * 350) / 100);
    },
    toPixelsY(y) {
      return Math.floor((y * 500) / 100);
    },
    gotoHome() {
      if (
        !this.confirmationRequired ||
        confirm(this.$t("global.confirmation_go_home"))
      ) {
        RosService.sendHarvestCommand("Goto", this.farm.homeX, this.farm.homeY);
        this.clearFlare();
      }
    },
    gotoUnload() {
      if (
        !this.confirmationRequired ||
        confirm(this.$t("global.confirmation_unload"))
      ) {
        RosService.sendHarvestCommand(
          "Unload",
          this.farm.homeX,
          this.farm.homeY
        );
        this.clearFlare();
      }
    },
    clearFlare() {
      this.$store.dispatch("chat/setAttribute", { gotoX: null });
      this.$store.dispatch("chat/setAttribute", { gotoY: null });
    },
    openDialog() {
      this.$modal.show("dialog", {
        // title: 'The standard Lorem Ipsum passage',
        text: this.$t("global.confirmation_question"),
        buttons: [
          {
            title: this.$t("global.cancel"),
            handler: () => {
              this.$modal.hide("dialog");
            }
          },
          {
            title: this.$t("global.ok"),
            handler: () => {
              alert(this.$t("harvest.respost_action"));
            }
          }
        ]
      });
    },
    globalToRos(viewer, x, y) {
      var rosX = (x - viewer.scene.x) / viewer.scene.scaleX;
      var rosY = (viewer.scene.y - y) / viewer.scene.scaleY;
      return new ROSLIB.Vector3({
        x: rosX,
        y: rosY
      });
    },
    rosToGlobal(viewer, pos) {
      var x = pos.x * viewer.scene.scaleX + viewer.scene.x;
      var y = -(viewer.scene.scaleY * pos.y - viewer.scene.y); // Flip Y coordinates
      return {
        x: x,
        y: y
      };
    }
  }
};
</script>
<style scoped>
.material-icons {
  line-height: 36px;
}
.map img {
  width: 100%;
}
.map {
  padding-top: 5px;
  position: relative;
  min-height: 100%;
}

.flare {
  position: absolute;
  z-index: 10;
  color: red;
  left: 0;
  top: 0;
}
</style>